<template>
  <Container>
    <h1>Statistiques</h1>

    <div class="honorsContainer">
      <div class="honor" v-if="mostEffectivePlayer" :style="'background-color: ' + mostEffectivePlayer.teamColor">
        <div class="honorTitle">Le plus efficace</div>
        <p class="honorName">{{mostEffectivePlayer.player.firstname}} {{mostEffectivePlayer.player.name}}</p>
        <p>avec {{mostEffectivePlayer.pointsWon - mostEffectivePlayer.pointsLost}} points gagnés de plus que de points perdus</p>
      </div>    
      <div class="honor" v-if="mostEnduringPlayer" :style="'background-color: ' + mostEnduringPlayer.teamColor">
        <div class="honorTitle">Le plus endurant</div>
        <p class="honorName">{{mostEnduringPlayer.player.firstname}} {{mostEnduringPlayer.player.name}}</p>
        <p>avec {{mostEnduringPlayer.pointsPlayed}} points joués</p>
      </div>
      <div class="honor" v-if="mostLazyPlayer" :style="'background-color: ' + mostLazyPlayer.teamColor">
        <div class="honorTitle">Le plus fainéant</div>
        <p class="honorName">{{mostLazyPlayer.player.firstname}} {{mostLazyPlayer.player.name}}</p>
        <p>avec {{mostLazyPlayer.pointsPlayed}} points joués</p>
      </div>
    </div>

    <table>
        <thead>
          <tr>
            <th>Joueur</th>
            <th><a href="#" v-on:click="sortPlayersByHat()">🤠</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchWon')">Matchs gagnés</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchSingleWon')">Simples gagnés</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchDoubleWon')">Doubles gagnés</a></th>  
            <th><a href="#"  v-on:click="sortPlayersBy('matchSetWon')">Sets gagnés</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('pointsWon')">Points gagnés</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchDraw')">Matchs nuls</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchLost')">Matchs perdus</a></th>          
            <th><a href="#"  v-on:click="sortPlayersBy('matchSingleLost')">Simples perdus</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchDoubleLost')">Doubles perdus</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchSetLost')">Sets perdus</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('pointsLost')">Points perdus</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('pointsWonMinusPointsLost')">Points gagnés moins Points perdus</a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="playerStats in stats" v-bind:key="playerStats.player.id" :style="'background-color: ' + playerStats.teamColor">
            <td>{{playerStats.player.firstname}} {{playerStats.player.name}}</td>
            <td>{{playerStats.player.hat}}</td>
            <td>{{playerStats.matchWon}}</td>
            <td>{{playerStats.matchSingleWon}}</td>
            <td>{{playerStats.matchDoubleWon}}</td>
            <td>{{playerStats.matchSetWon}}</td>
            <td>{{playerStats.pointsWon}}</td>
            <td>{{playerStats.matchDraw}}</td>
            <td>{{playerStats.matchLost}}</td>
            <td>{{playerStats.matchSingleLost}}</td>
            <td>{{playerStats.matchDoubleLost}}</td>
            <td>{{playerStats.matchSetLost}}</td>
            <td>{{playerStats.pointsLost}}</td>
            <td>{{playerStats.pointsWonMinusPointsLost}}</td>
          </tr>          
        </tbody>
      </table>
  </Container>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Container from '@/components/Container.vue';

export default {
  name: "stats",
  data: function(){
    return {
      stats : []
    }
  },
  components: {
    Container
  },
  computed: {
    mostEnduringPlayer() {
      return (this.stats.length > 0) ? this.stats.reduce((x, y) => (x.pointsPlayed - y.pointsPlayed > 0) ? x : y) : "";
    },
    mostLazyPlayer() {
      return (this.stats.length > 0) ? this.stats.reduce((x, y) => (x.pointsPlayed - y.pointsPlayed < 0) ? x : y) : "";
    },
    mostEffectivePlayer() {
      return (this.stats.length > 0) ? this.stats.reduce((x, y) => ((x.pointsWonMinusPointsLost) - (y.pointsWonMinusPointsLost) > 0) ? x : y) : "";
    }
  },
  mounted() {
    axios
      .get("/stats")
      .then(response => {
        this.stats = response.data;
      });
  },
  methods: {
    sortPlayersBy(sortKey){
      this.stats = this.stats.sort((x, y) => y[sortKey] - x[sortKey])
    },
    sortPlayersByHat(){
      this.stats = this.stats.sort((x, y) => x.player.hat - y.player.hat)
    }
  }
};
</script>
<style scoped>
.honorsContainer{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 20px;
}
.honor{
  box-shadow: 0.1em 0.3em 0.4em #ddd;
  margin-left: 10px;
  margin-right: 10px;
}
.honorTitle{
  text-align: center;
  background-color: #f1f1f1;
  color: #404040;
  padding-top: 10px;
  padding-bottom: 10px;
}
.honor p{
  margin-left: 10px;
  margin-right: 10px;
}
.honorName{
  color: #404040;
  font-weight: bold;
  font-size: 1.4em;
}

tbody td{
  padding: 10px;
}
thead{
  background-color: #f1f1f1;
}
thead th{
  color: #404040;
  padding: 10px;
}
thead th a{
  color: #404040;
}
table {
  margin-bottom: 20px;
}

</style>
